import {
  HchbCoordinationNotesRepositoryFactory,
  type HchbCoordinationNoteSource,
} from "../../adapters/driven/repositories/hchbCoordinationNotesRepository";

export const HchbCoordinationNotesServiceImplFactory = ({
  hchbCoordinationNotesRepository,
}: {
  hchbCoordinationNotesRepository: ReturnType<
    typeof HchbCoordinationNotesRepositoryFactory
  >;
}) => {
  const getNoteTypes = async ({
    clinicId,
    patientId,
  }: {
    clinicId: number;
    patientId: number;
  }) => {
    try {
      const result = await hchbCoordinationNotesRepository.getNoteTypesAPI({
        clinic_id: clinicId,
        patient_id: patientId,
      });
      return { success: true as const, data: result };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  const listNotes = async ({
    clinicId,
    patientId,
    limit,
    offset,
    source,
  }: {
    clinicId: number;
    patientId: number;
    limit?: number;
    offset?: number;
    source?: HchbCoordinationNoteSource | null;
  }) => {
    try {
      const result = await hchbCoordinationNotesRepository.listNotesAPI({
        clinic_id: clinicId,
        patient_id: patientId,
        limit,
        offset,
        source,
      });
      return { success: true as const, data: result };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  const createNote = async ({
    clinicId,
    patientId,
    hchbNoteType,
    hchbNoteTypeDescription,
    noteMessage,
    source,
  }: {
    clinicId: number;
    patientId: number;
    hchbNoteType: string;
    hchbNoteTypeDescription?: string;
    noteMessage: string;
    source?: HchbCoordinationNoteSource | null;
  }) => {
    try {
      const result = await hchbCoordinationNotesRepository.createNoteAPI({
        clinic_id: clinicId,
        patient_id: patientId,
        hchb_note_type: hchbNoteType,
        hchb_note_type_description: hchbNoteTypeDescription,
        note_message: noteMessage,
        source,
      });
      return { success: true as const, data: result };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  const retryNote = async ({
    clinicId,
    patientId,
    coordinationNoteId,
  }: {
    clinicId: number;
    patientId: number;
    coordinationNoteId: number;
  }) => {
    try {
      const result = await hchbCoordinationNotesRepository.retryNoteAPI({
        clinic_id: clinicId,
        patient_id: patientId,
        coordination_note_id: coordinationNoteId,
      });
      return { success: true as const, data: result };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  return { getNoteTypes, listNotes, createNote, retryNote };
};
